import { render } from "./timeline-item.vue?vue&type=template&id=8b8d68b2"
import script from "./timeline-item.vue?vue&type=script&lang=js"
export * from "./timeline-item.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/thecompcodes-dashboard/thecompcodes-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__